type ErrorObj = {
  [x: string]: any;
};

export const extractErrorMessage = (
  index: number,
  errors: ErrorObj,
  daysType: "nominalDays" | "exceptionDays"
): string | undefined => (errors[daysType] ? errors[daysType][index]?.workingMinutes?.message : undefined);

export const extractDateErrorMessage = (
  index: number,
  errors: ErrorObj,
  daysType: "nominalDays" | "exceptionDays"
): string | undefined => (errors[daysType] ? errors[daysType][index]?.date?.message : undefined);
